import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-component',
  templateUrl: './ui-component.component.html'
})
export class UiComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/ui-component/ui-component.component.ts